import { Component } from 'react';

import Loader from 'hb-react/shared/components/Loader';

class Iframe extends Component {
  state = { isLoading: true };

  componentDidMount() {
    this.iframe.addEventListener('load', this.triggersIframeCallback);
  }

  componentWillUnmount() {
    this.iframe.removeEventListener('load', this.triggersIframeCallback);
  }

  triggersIframeCallback = () => {
    this.setState({ isLoading: false });
  };

  render() {
    const { isLoading } = this.state;

    return (
      <div style={{ height: '100%' }}>
        {isLoading && <Loader full />}
        <iframe
          {...this.props}
          ref={(ref) => (this.iframe = ref)}
          style={{ width: isLoading && 0 }}
        />
      </div>
    );
  }
}

export default Iframe;
